import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as IconBlogArrowRight } from '../../assets/iconpack/icon1-blog-arrow-right.svg';
import { ReactComponent as IconBlogAvatar } from '../../assets/iconpack/icon2-blog-avatar.svg';
import { ReactComponent as IconBlogBeverage } from '../../assets/iconpack/icon3-blog-beverage.svg';
import { ReactComponent as IconBlogBottle } from '../../assets/iconpack/icon4-blog-bottle.svg';
import { ReactComponent as IconBlogBurger } from '../../assets/iconpack/icon5-blog-burger.svg';
import { ReactComponent as IconBlogBus } from '../../assets/iconpack/icon6-blog-bus.svg';
import { ReactComponent as IconBlogCamera } from '../../assets/iconpack/icon7-blog-camera.svg';
import { ReactComponent as IconBlogCar } from '../../assets/iconpack/icon8-blog-car.svg';
import { ReactComponent as IconBlogCar2 } from '../../assets/iconpack/icon9-blog-car2.svg';
import { ReactComponent as IconBlogChecklist } from '../../assets/iconpack/icon10-blog-checklist.svg';
import { ReactComponent as IconBlogCheckmark } from '../../assets/iconpack/icon11-blog-checkmark.svg';
import { ReactComponent as IconBlogCompany } from '../../assets/iconpack/icon12-blog-company.svg';
import { ReactComponent as IconBlogCompass } from '../../assets/iconpack/icon13-blog-compass.svg';
import { ReactComponent as IconBlogConnector } from '../../assets/iconpack/icon14-blog-connector.svg';
import { ReactComponent as IconBlogCross } from '../../assets/iconpack/icon15-blog-cross.svg';
import { ReactComponent as IconBlogEmojiSmiling } from '../../assets/iconpack/icon16-blog-emoji-smiling.svg';
import { ReactComponent as IconBlogExclamationMark } from '../../assets/iconpack/icon17-blog-exclamation-mark.svg';
import { ReactComponent as IconBlogFacebook } from '../../assets/iconpack/icon18-blog-facebook.svg';
import { ReactComponent as IconBlogFish } from '../../assets/iconpack/icon19-blog-fish.svg';
import { ReactComponent as IconBlogFood } from '../../assets/iconpack/icon20-blog-food.svg';
import { ReactComponent as IconBlogGoogle } from '../../assets/iconpack/icon21-blog-google.svg';
import { ReactComponent as IconBlogHeart } from '../../assets/iconpack/icon22-blog-heart.svg';
import { ReactComponent as IconBlogHome } from '../../assets/iconpack/icon23-blog-home.svg';
import { ReactComponent as IconBlogInfo } from '../../assets/iconpack/icon24-blog-info.svg';
import { ReactComponent as IconBlogInstagram } from '../../assets/iconpack/icon25-blog-instagram.svg';
import { ReactComponent as IconBlogManSkiing } from '../../assets/iconpack/icon26-blog-man-skiing.svg';
import { ReactComponent as IconBlogManSwimming } from '../../assets/iconpack/icon27-blog-man-swimming.svg';
import { ReactComponent as IconBlogManWalking } from '../../assets/iconpack/icon28-blog-man-walking.svg';
import { ReactComponent as IconBlogMedal } from '../../assets/iconpack/icon29-blog-medal.svg';
import { ReactComponent as IconBlogMoneyBill } from '../../assets/iconpack/icon30-blog-money-bill.svg';
import { ReactComponent as IconBlogMoneyDollar } from '../../assets/iconpack/icon31-blog-money-dollar.svg';
import { ReactComponent as IconBlogMoneyEuro } from '../../assets/iconpack/icon32-blog-money-euro.svg';
import { ReactComponent as IconBlogPaperPlane } from '../../assets/iconpack/icon33-blog-paperplane.svg';
import { ReactComponent as IconBlogPaperPlane2 } from '../../assets/iconpack/icon34-blog-paperplane2.svg';
import { ReactComponent as IconBlogPassport } from '../../assets/iconpack/icon35-blog-passport.svg';
import { ReactComponent as IconBlogPizza } from '../../assets/iconpack/icon36-blog-pizza.svg';
import { ReactComponent as IconBlogPlane } from '../../assets/iconpack/icon37-blog-plane.svg';
import { ReactComponent as IconBlogPlus } from '../../assets/iconpack/icon38-blog-plus.svg';
import { ReactComponent as IconBlogQuestionMark } from '../../assets/iconpack/icon39-blog-question-mark.svg';
import { ReactComponent as IconBlogRisk } from '../../assets/iconpack/icon40-blog-risk.svg';
import { ReactComponent as IconBlogThumbsDown } from '../../assets/iconpack/icon41-blog-thumbs-down.svg';
import { ReactComponent as IconBlogThumbsRight } from '../../assets/iconpack/icon42-blog-thumbs-right.svg';
import { ReactComponent as IconBlogThumbsUp } from '../../assets/iconpack/icon43-blog-thumbs-up.svg';
import { ReactComponent as IconBlogTicket } from '../../assets/iconpack/icon44-blog-ticket.svg';
import { ReactComponent as IconBlogTrain } from '../../assets/iconpack/icon45-blog-train.svg';
import { ReactComponent as IconBlogWaves } from '../../assets/iconpack/icon46-blog-waves.svg';
import { ReactComponent as IconBlogWifi } from '../../assets/iconpack/icon47-blog-wifi.svg';
import { ReactComponent as IconBlogWine } from '../../assets/iconpack/icon48-blog-wine.svg';
import { ReactComponent as IconBlogBeer2 } from '../../assets/iconpack/icon49-blog-beer2.svg';
import { ReactComponent as IconBlogBus2 } from '../../assets/iconpack/icon50-blog-bus2.svg';
import { ReactComponent as IconBlogKiosk } from '../../assets/iconpack/icon51-blog-kiosk.svg';
import { ReactComponent as IconBlogMenu } from '../../assets/iconpack/icon52-blog-menu.svg';
import { ReactComponent as IconBlogShipping } from '../../assets/iconpack/icon53-blog-shipping.svg';

const getIcon = (iconName) => {
  switch (iconName) {
    case 'icon1':
    default:
      return <IconBlogArrowRight />;
    case 'icon2':
      return <IconBlogAvatar />;
    case 'icon3':
      return <IconBlogBeverage />;
    case 'icon4':
      return <IconBlogBottle />;
    case 'icon5':
      return <IconBlogBurger />;
    case 'icon6':
      return <IconBlogBus />;
    case 'icon7':
      return <IconBlogCamera />;
    case 'icon8':
      return <IconBlogCar />;
    case 'icon9':
      return <IconBlogCar2 />;
    case 'icon10':
      return <IconBlogChecklist />;
    case 'icon11':
      return <IconBlogCheckmark />;
    case 'icon12':
      return <IconBlogCompany />;
    case 'icon13':
      return <IconBlogCompass />;
    case 'icon14':
      return <IconBlogConnector />;
    case 'icon15':
      return <IconBlogCross />;
    case 'icon16':
      return <IconBlogEmojiSmiling />;
    case 'icon17':
      return <IconBlogExclamationMark />;
    case 'icon18':
      return <IconBlogFacebook />;
    case 'icon19':
      return <IconBlogFish />;
    case 'icon20':
      return <IconBlogFood />;
    case 'icon21':
      return <IconBlogGoogle />;
    case 'icon22':
      return <IconBlogHeart />;
    case 'icon23':
      return <IconBlogHome />;
    case 'icon24':
      return <IconBlogInfo />;
    case 'icon25':
      return <IconBlogInstagram />;
    case 'icon26':
      return <IconBlogManSkiing />;
    case 'icon27':
      return <IconBlogManSwimming />;
    case 'icon28':
      return <IconBlogManWalking />;
    case 'icon29':
      return <IconBlogMedal />;
    case 'icon30':
      return <IconBlogMoneyBill />;
    case 'icon31':
      return <IconBlogMoneyDollar />;
    case 'icon32':
      return <IconBlogMoneyEuro />;
    case 'icon33':
      return <IconBlogPaperPlane />;
    case 'icon34':
      return <IconBlogPaperPlane2 />;
    case 'icon35':
      return <IconBlogPassport />;
    case 'icon36':
      return <IconBlogPizza />;
    case 'icon37':
      return <IconBlogPlane />;
    case 'icon38':
      return <IconBlogPlus />;
    case 'icon39':
      return <IconBlogQuestionMark />;
    case 'icon40':
      return <IconBlogRisk />;
    case 'icon41':
      return <IconBlogThumbsDown />;
    case 'icon42':
      return <IconBlogThumbsRight />;
    case 'icon43':
      return <IconBlogThumbsUp />;
    case 'icon44':
      return <IconBlogTicket />;
    case 'icon45':
      return <IconBlogTrain />;
    case 'icon46':
      return <IconBlogWaves />;
    case 'icon47':
      return <IconBlogWifi />;
    case 'icon48':
      return <IconBlogWine />;
    case 'icon49':
      return <IconBlogBeer2 />;
    case 'icon50':
      return <IconBlogBus2 />;
    case 'icon51':
      return <IconBlogKiosk />;
    case 'icon52':
      return <IconBlogMenu />;
    case 'icon53':
      return <IconBlogShipping />;
  }
};

const BlogIcon = (props) => {
  const { iconName, ...rest } = props;
  return React.cloneElement(getIcon(iconName), { ...rest });
};

BlogIcon.propTypes = {
  iconName: PropTypes.string.isRequired,
};

export default BlogIcon;
